import React from 'react';
import PropTypes from 'prop-types';

/**
 * Table cell represents responsive column data.
 *
 * @param {{}} props
 * @constructor
 */
const ResponsiveCell = (props) => {
    function renderColumns() {
        return props.customCell.options.columns.map((col, index) =>
            <span className={col.className} key={index}>{props.rowData[col.name]}</span>
        );
    }

    return (
        <span>
            {renderColumns()}
        </span>
    );
};

ResponsiveCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default ResponsiveCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/ResponsiveCell.js